import React from "react";
import Header from "../components/Header";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "./About.css";

const data = {
  heading: "About Me",
  image: "/images/about.svg",
  profile: "/images/pfp.jpeg",
};

const About = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Header heading={data.heading} image={data.image} />
      <div className="about-container">
        <div className="a-left">
          <p>
            I am a web developer playing and exploring with new frameworks and
            libraries. I started my developement journey by learning Java and
            built various apps during my internship. Then I moves towards web
            development, learnt HTML, CSS, JavaScript, React, NodeJS, Express,
            MongoDB and more. Explored various styling libraries like bootstrap,
            tailwind and chakra-ui. Built various apps using these libraries. I
            am also looking forward to explore blockchain domain and build a
            decentralized applications.I also did competitive programming in
            intial years but later got interest in development. Also I got to
            learn about various data structures and algorithms during the
            process. Do visit my profiles of different platforms, to know more
            visit skills section.
          </p>
          <h2>Education</h2>
          <ul>
            <li className="ed-item">
              <h3>JAYPEE INSTITUTE OF INFORMATION TECHNOLOGY - (2019-2023)</h3>
              Bachelor of Technology (B.Tech) in Computer Science and
              Engineering
              <br />
              Current CGPA - 8.1
            </li>
            <li className="ed-item">
              <h3>ST. GEORGE'S SCHOOL - (2015-2019)</h3>
              10th Standard: 10 CGPA
              <br />
              12th Standard: 93.6% (Science)
            </li>
          </ul>
          {/* <h2>Certifications</h2>
          <div className="ed-item">
            <ul>
              <li>MERN Stack (Grade 4) - (Jan 2022)</li>
              <li>Docker - (Nov 2021)</li>
              <li>Core Python - (May 2019)</li>
            </ul>
          </div> */}
        </div>
        <div className="a-right">
          <img src={data.profile} alt="profile" className="pfp" />
        </div>
      </div>
      <Link to="/" className="home">
        Home
      </Link>
    </motion.div>
  );
};

export default About;
